export class Arquivo {
  arquivo = '';

  constructor() {
    this.arquivo = '';
  }

  add(texto: string) {
    this.arquivo += texto;
  }

  addLine() {
    this.arquivo += '\n';
  }

  getArquivo() {
    return this.arquivo;
  }
}
